import React from 'react';
import { Input, Icon } from '@chakra-ui/react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { InputGroup } from '@/components/ui/input-group';

interface Props {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  placeholder?: string;
}

/**
 * Search box for list/library pages (content libraries, collections, …).
 * Shared list control — keep page-specific behaviour in the caller.
 */
const Search: React.FC<Props> = ({ searchQuery, onSearchChange, onClearSearch, placeholder }) => {
  return (
    <InputGroup
      w={'full'}
      startElement={<Icon as={MagnifyingGlassIcon} w={4} h={4} />}
      endElement={<Icon as={XMarkIcon} w={4} h={4} onClick={onClearSearch} />}
    >
      <Input placeholder={placeholder ?? 'Search ...'} value={searchQuery} onChange={onSearchChange} />
    </InputGroup>
  );
};

export default Search;
